/* import __COLOCATED_TEMPLATE__ from './follow-up-reply-overlay.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import BaseFilterBlockPopover from 'predicates/components/filter-block/base-filter-block-popover';
import { action } from '@ember/object';

export default class FollowUpReplyOverlay extends BaseFilterBlockPopover {
  @action
  onInput(event) {
    if (event.target.value) {
      this.componentAttrs.onChange(event.target.value);
    }
  }
}
